import React from "react";
import styles from "./Tabs.module.scss";
import { combineClasses } from "@/lib/utils";

interface TabsProps {
  tabs: readonly string[];
  activeIndex: number;
  onChange: (index: number) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeIndex, onChange, className = "" }) => (
  <div className={combineClasses(styles.tabPanel, className)}>
    {tabs.map((tab, index) => (
      <button
        type="button"
        key={tab}
        className={combineClasses(styles.tabName, activeIndex === index && styles.active)}
        onClick={() => onChange(index)}
      >
        {tab}
      </button>
    ))}
  </div>
);

export default Tabs;
